// extracted by mini-css-extract-plugin
module.exports = {"container":"B_b","noTopMargin":"B_bN","filename":"B_bP"};